module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-13-4a1a36c0239cbf84c30df3730660d6e5.jpg";